// extracted by mini-css-extract-plugin
export default {"canvas":"_5lZqlhE"};